/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260603
*/
'use strict';

import {
    getMySNApiError,
    getPromise,
    patchPromise,
    savePromise
} from './ctssJQuery.js';
import {
    parseToken,
    setToken,
} from './ctssJWT.js';
import {
    confirmedPW,
    enableBtn,
    validEmail,
    validPW
} from './ctssVal.js';
import {
    adminPortalURL,
    getAppToken,
    redirectToHomeURL
} from './snSite.js';


let loginList = [];

const changePWAsync = async () => {
    await savePromise({
        url: 'MemberAuthentication/ChangePW',
        data: { OldPW: $('#editOldPW').val(), NewPW: $('#editNewPW').val() },
        divErrMsg: '#divChangePWErrMsg'
    });
    $('#pwDlg').modal('hide');
    $('#successDlg').modal('show');
}

const displayEmailDlg = () => {
    $('#divErrMsg').addClass('hidden');
    $('#emailDlg').modal('show');
}

const forgotPWAsync = async (params = {}) => {
    await getPromise({
        url: `MemberAuthentication/${params.email}/ForgotPW?adminPortalURL=${adminPortalURL}`,
        useCookie: false
    });
}
const getEmailExistsAsync = async (params = {}) => 
    await getPromise({ url: `MemberAuthentication/${params.email}/EmailExists` });

const getLoginListAsync = async (params) => {

    const getLoginListItem = (church) =>
        `<tr id=${church.cg}><td class="col-md-10">${church.church}</td>` +
        '<td class="col-md-2"><button class="btn btn-sm">Login</td></tr>';

    try {
        loginList = await getPromise({
            url: `Churches/${getAppToken().sub}/LoginMenu`,
            dataType: 'json',
            divErrMsg: '#divChurchListDlgErrMsg'
        })
        const loginListItems = loginList.reduce((content, church) =>
            content + getLoginListItem(church), '');
        $('#gridChurches tbody')
            .empty()
            .append(loginListItems)
            .on('click', (e) => {
                const cg = e.target.closest('tr').id;
                selectChurchAsync({ cg });
            });

    }
    catch (error) { }
}

const initChurchesDlg = () =>
    $('#churchesDlg').on('show.bs.modal', getLoginListAsync);

const sendForgotPWEmail = async () => {

    $('emailDlg').modal('hide');

    await forgotPWAsync({ email: $('#destEmail').val() });

    const msg = 'If you have an account with us you will be sent an email ' +
        'with a password reset link. This could take a few minutes. You will ' +
        'have 24 hours to reset your password using the link.';

    showLinkDlg({
        linkDlgHdr: 'Resetting Your Password',
        linkMsg: msg
    });
}
const sentVerifyLinkEmail = async () => {

    $('#divErrMsg').addClass('hidden');

    await getPromise({
        url: `MemberAuthentication/${$('#email').val()}/Verification`,
        useCookie: false
    });

    showLinkDlg({
        linkDlgHdr: 'Your verification email has been sent...',
        linkMsg: 'Please click on the link in your email to complete' +
            'the process of joining My Sermon Notes...'
    });
}

const showLinkDlg = (params) => {
    $('#linkDlgHdr').text(params.linkDlgHdr);
    $('#linkMsg').text(params.linkMsg);
    $('#linkDlg').modal('show');
}

const showOAuthResetLinkDlg = (params) => {
    $('#oAuthResetLinkDlgHdr').text(params.linkDlgHdr);
    $('#oAuthResetLinkDlgMsg').text(params.linkMsg);
    $('#oAuthResetLinkDlg').modal('show');
}

const signIn = async (params) => {
    const divErrMsg = params.divErrMsg === undefined ? '#divErrMsg' : '#divRefreshLoginDlgErrMsg';
    const signInParams = {
        email: params.email,
        pw: params.pw,
        authMethod: params.authMethod,
        fromPortal: params.fromPortal
    };
    try {
        const data = await savePromise({
            url: 'MemberAuthentication/PortalSignIn',
            data: signInParams,
            divErrMsg: divErrMsg,
            fnErr: (data) => {
                const errMsg = getMySNApiError(data);
                $(divErrMsg).text(errMsg).removeClass('hidden');
                if (errMsg === 'You must verify your account by clicking on the verification link emailed to you...') {
                    $('#link').text('Send Verification Link Email');
                    $('#link').off('click').on('click', sentVerifyLinkEmail);
                }
            }
        })
        $(divErrMsg).addClass('hidden');
        if (typeof (Storage) !== undefined) {
            setToken({ tokenNm: 'sNotes', token: data.token });
        }
        const token = parseToken({ token: data.token });
        if (token.IsMultiChurchAdmin === "True") {
            $('#churchesDlg').modal('show');
        } else {
            const url = token.IsAdmin === "False"
                ? token.GroupLeaderRights.length > 0
                    ? "../Home/GroupLeaderPortalMenu"
                    : "../Home/MemberPortalMenu"
                : "../Home";
            if (params.recallFn === undefined) {
                window.location.href = url;
            } else {
                $('#refreshLoginDlg').modal('hide');
                params.recallFn();
            }
        }
    }
    catch (error) { }
}

/* OAuth Deprecation Functions */

const getProviderNm = (authMethod) =>
    authMethod === 1 ? 'Google' :
    authMethod === 2 ? 'Facebook' :
    authMethod === 3 ? 'Apple' : 'Unknown';

/* OAuth Functions */

let providerName = '';

const appleLogin = () => showOAuthDeprecatedDlg(3);

const fbLogin = () => showOAuthDeprecatedDlg(2);

const googleLogin = () => showOAuthDeprecatedDlg(1);    

const closeOAuthDlgs = () => {
    $('#oAuthResetLinkDlg').modal('hide');
    $('#oAuthDeprecatedDlg').modal('hide');
}

const processOAuthEmail = async () => {

    const oAuthEmail = $('#oAuthEmail').val();

    if (!oAuthEmail) {
        $('#divOAuthErrMsg').text('Please enter an email...').removeClass('hidden');
        return;
    }

    const isValidEmail =
        await getEmailExistsAsync({ email: oAuthEmail }) 

    if (isValidEmail) {
        $('#email').val(oAuthEmail);
        await forgotPWAsync({ email: oAuthEmail });
        showOAuthResetLinkDlg({
            linkDlgHdr: 'Creating Your Password',
            linkMsg: 'You will be emailed a password reset link. Click on the link ' +
                'to create your My Sermon Notes password. This could take a few minutes. You will ' +
                'have 24 hours to reset your password using the link.'
        });
    }
    else {
        $('#divErrMsg').text(`Invalid Continue with ${providerName} email...`).removeClass('hidden'); 
    }

    $('#oAuthDeprecatedlDlg').modal('hide');
}

const showOAuthDeprecatedDlg = (authMethod) => {
    if (authMethod === 3) {
        $('#divAppleMsg').removeClass('hidden');
    }
    else {
        $('#divAppleMsg').addClass('hidden');
    }
    providerName = getProviderNm(authMethod);
    $('#providerName').text(providerName); 
    $('#providerNmForTitle').text(providerName); 
    $('#divOAuthErrMsg').addClass('hidden');
    $('#oAuthDeprecatedDlg').modal('show');
};

const initResetPW = () => {
    $('#btnCancel').on('click', redirectToHomeURL);
    $('#editNewPW').on('input keyup',
        () => setValidationForEditNewPW({
            btnNm: '#btnResetPW',
            requiredCtrlNms: ['#editNewPW', '#editConfirmPW']
        }));
    $('#editConfirmPW').on('input keyup',
        () => setValidationForConfirmPW({ btnNm: '#btnResetPW' }));
};

const init = () => {
    initChurchesDlg();
    $('#email,#pw').val('');
    $('#email,#pw').on('input keyup', () => {
        $('#pw').val().length < 8
            ? enableBtn({ isEnabled: false, btnNm: '#btnSignIn' })
            : enableBtn({
                requiredCtrlNms: ['#email', '#pw'],
                btnNm: '#btnSignIn'
            });
    });
    $('#link').off('click').on('click', displayEmailDlg);
    $('#emailDlg').on('show.bs.modal', (e) => {
        $('#destEmail').val($('#email').val());
        enableBtn({
            btnNm: '#btnSendEmail',
            isEnabled: $('#destEmail').val().length === 0
                ? false
                : validEmail({
                    emailCtrl: 'destEmail',
                    emailErrMsgId: 'emailErrMsg'
                })
        });
    });
    $('#destEmail').on('keyup',
        () => enableBtn({
            btnNm: '#btnSendEmail',
            isEnabled: validEmail({
                emailCtrl: 'destEmail',
                emailErrMsgId: 'emailErrMsg'
            })
        }));

    $('#btnSendEmail').off('click').on('click', sendForgotPWEmail);
    $('#appleSignInBtn').off('click').on('click', appleLogin);
    $('#facebookSignInBtn').off('click').on('click', fbLogin);
    $('#googleSignInBtn').off('click').on('click', googleLogin);
    $('#btnProcessOAuthEmail').off('click').on( 'click', processOAuthEmail);
    $('#btnAOuthResetLinkDlgOk').off('click').on('click', closeOAuthDlgs);
    $('#btnSignIn').off('click').on('click', () => signInWEmail());
};

const resetPWAsync = async (params) => {
    await patchPromise({
        url: 'MemberAuthentication/ResetPW',
        data: { ResetId: params.resetId, NewPW: $('#editNewPW').val() }
    });
    $('#successDlg').modal('show');
};

const selectChurchAsync = async (params) => {

    const data = await savePromise({
        url: 'Churches/Login',
        data: loginList.find(x => x.cg === params.cg),
        divErrMsg: '#divChurchListDlgErrMsg'
    });

    if (typeof (Storage) !== undefined) {
        setToken({ tokenNm: 'sNotes', token: data.token });
    }
    $('#churchesDlg').modal('hide');
    if (params.recallFn === undefined) {
        window.location.href = "../Home";
    } else {
        $('#refreshLoginDlg').modal('hide');
        params.recallFn();
    }
};

const setValidationForConfirmPW = (params) => {
    let isPWConfirmed = confirmedPW({
        pwCtrl: 'editNewPW',
        confirmPWErrMsgId: 'confirmPWErrMsgId'
    });
    if (params.checkOldPW === true) {
        isPWConfirmed = $('#editOldPW').val().length > 0 && isPWConfirmed;
    }
    isPWConfirmed
        ? $(params.btnNm).removeAttr('disabled')
        : $(params.btnNm).prop('disabled', true);
}

const setValidationForEditNewPW = (params) => {
    console.log('validating new pw');
    validPW({
        pwCtrl: 'editNewPW',
        minQty: 8,
        minLenMsgId: 'pwLen',
        uppercaseMsgId: 'pwUpper',
        lowercaseMsgId: 'pwLower',
        numberMsgId: 'pwNumber',
        specialCharMsgId: 'pwSpecial'
    });
    enableBtn({
        btnNm: params.btnNm,
        requiredCtrlNms: params.requiredCtrlNms
    });
}

const signInWEmail = (params) => {
    const email = params === undefined ? $('#email').val() : $('#refreshEmail').val();
    const pw = params === undefined ? $('#pw').val() : $('#refreshPw').val();
    const signInParams = { email: email, pw: pw, authMethod: 0, fromPortal: true };
    signIn(signInParams);
};

const signOut = () => {
    localStorage.removeItem('sNotes');
    window.location.href = "../Home/SignIn";
};

export {
    changePWAsync,
    fbLogin,
    getEmailExistsAsync,
    initResetPW,
    init,
    resetPWAsync,
    selectChurchAsync,
    setValidationForConfirmPW,
    setValidationForEditNewPW,
    signInWEmail,
    signOut
};

window.snMemberAuthentication = {
    initResetPW,
    init,
    resetPWAsync,
    signOut
};